<template>
 <div class="row mx-0 justify-content-center">
     <div class="col-lg-6 text-center  col-lg-6 col-md-6 col-10 pt-2 login-img">
        <a class="llp-logo" href="/">
          <img :alt="Logo" :aria-label="Logo" src="/images/makbilllogo.png" class="img-fluid1" />
        </a>
      </div>
       
   <div class="col-lg-6  col-md-6 col-sm-6  d-flex justify-content-center align-items-center">
       <form class="d-grid" @submit.prevent="doResetPassword">
                            <div class="row justify-content-center p-2">
                  <h4 class="otp-heading">Reset Password</h4>
                </div>
                            <div class="row justify-content-center p-2">
                                <llp-label id="password-label"
                                           :aria-label="PASSWORD">
                                           Password:
                                </llp-label>
                                <llp-input id="password"
                                           v-model:modelValue="credential.password"
                                           :errors="validator.credential.password.$errors"
                                           type="password">
                                </llp-input>
                            </div>
                            <div class="row justify-content-center p-2">
                                <llp-label id="confirm-password-label" :aria-label="confirm_password">
                                  Confirm Password:
                                </llp-label>
                                <llp-input id="confirm-password" v-model:modelValue="credential.confirmPassword"
                                           :errors="validator.credential.confirmPassword.$errors" type="password">
                                </llp-input>
                            </div>
                            <div class="row justify-content-center p-2">
                                <div class="col-auto">
                                    <llp-button :loadSpinner="showSpinner" classNames="btn-secondary new-btn"
                                                type="submit">
                                                RESET
                                    </llp-button>
                                </div>
                            </div>
                        </form>
   </div>
   
 </div>
    <llp-toast ref="toast"></llp-toast>
</template>

<script>
import {helpers, required, sameAs,minLength} from '@vuelidate/validators';
import {useVuelidate} from '@vuelidate/core';
import ErrorService from '../../services/error.service';
import NetworkService from '../../services/network.service';

export default {
  name: 'ResetPasswordPage',
  setup: () => ({validator: useVuelidate()}),
  data() {
    return {
      credential: {
        password: '',
        confirmPassword: '',
      },
      token: '',
       email: '',

      messages: [],
      showSpinner: false,
    };
  },
  validations() {
    return {
      credential: {
        // email: {required: helpers.withMessage("This field cannot be empty", required)},
        password: {required: helpers.withMessage("This field cannot be empty", required),
           minLength: helpers.withMessage("Password must be at least 6 characters long", minLength(6))
        },
        confirmPassword: {
          required: helpers.withMessage("This field cannot be empty", required),
          sameAsNewPassword: helpers.withMessage("Confirm passwords do not match with password",
              sameAs(this.credential.password)),
        },
      },
    };
  },
  methods: {
  
  doResetPassword() {
  // Validate form first
  this.validator
    .$validate()
    .then((isValid) => {
      if (!isValid) return Promise.reject();

      // Ensure that token and email are present before proceeding
      if (!this.token || !this.email) {
        return Promise.reject("Token or Email is missing");
      }

      this.showSpinner = true;
      const data = {
        email: this.email,
        password: this.credential.password,
        password_confirmation:this.credential.confirmPassword,
        token: this.token,
      };
      return NetworkService.post('/reset-password', data);
    })
    .then((response) => {
      this.$refs.toast.show(response.data.message);
      setTimeout(() => {
        this.$router.push('/');
      }, 3000);
    })
    .catch((error) => {
      this.$refs.toast.show(ErrorService.getErrorMessages(error), 'error');
    })
    .finally(() => {
      this.showSpinner = false;
    });
}

  },
  
  

  mounted() {
  const paths = window.location.pathname.split('/');
  const tokenParam = paths[2]; 
  const emailParam = paths[3]; 
  const token1 = tokenParam.split('=')[1];
  const email1 = emailParam.split('=')[1];
  this.token = decodeURIComponent(token1);
  this.email = decodeURIComponent(email1);
}

};
</script>
